import {getCurrentYear} from '../../utils/commons'
import ExpertTopChoiceLogo from './logo'
import {expertTopChoiceStylesCA, expertTopChoiceStylesUS} from './styles'

const baseConfig = {
  domainName: 'expertstopchoice' as const,
  domainType: 'picks' as const,
  siteName: 'Expert Top Choice',
  favicon: '/favicons/expertstopchoice.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-ZV8ZLC4CGD',
    camelCaseUrl: 'ExpertTopChoice.com',
    title: (category: string, count: string) =>
      `Best ${count} ${category} Worth Buying in ${getCurrentYear()} – Expert Picks | ExpertsTopChoice.com`,
    description: (category?: string, _count?: string) =>
      `ExpertsTopChoice.com reviews the best ${category} you can buy in ${getCurrentYear()}. Our experts share trusted picks and insights to help you shop smarter.`,
    styles: expertTopChoiceStylesUS,
    logo: <ExpertTopChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="us" />,
  },
  ca: {
    measurementId: 'G-1KCGVJZT13',
    camelCaseUrl: 'ExpertTopChoice.ca',
    title: (category: string, _count: string) =>
      `Best ${category} ${getCurrentYear()} in Canada | ExpertsTopChoice.ca – Trusted Reviews & Top Picks`,
    description: (category?: string, _count?: string) =>
      `At ExpertsTopChoice.ca, we review and compare Canada’s best ${category} for ${getCurrentYear()}. Discover expert insights, verified reviews, and smart buying advice to help you choose with confidence.`,
    styles: expertTopChoiceStylesCA,
    logo: <ExpertTopChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
